export default __webpack_public_path__ + "static/Supreme-Medium-37b14d7c27baf9171c34ad7f0bcb5347.woff";